import cx from 'classnames';
import Image from 'next/image';
import { MouseEvent } from 'react';

import { IconChevronRight } from '../../../../design-system/components/icons/ChevronRight';
import { IconGlobe } from '../../../../design-system/components/icons/Globe';
import { IconMap } from '../../../../design-system/components/icons/Map';
import { RATIO } from '../../../../design-system/components/ratio/Ratio';
import { Typography } from '../../../../design-system/components/typography/Typography';
import { imageLoaderForPicture } from '../../../Layout/Image/URL/ImageURL';
import { FallbackRow } from '../../utils/fallbackRows';

import style from './FallbackRowItem.module.css';

type Props = {
    row: FallbackRow;
    id: string;
    isActive: boolean;
    isPending: boolean;
    isDisabled: boolean;
    itemRef: (el: HTMLAnchorElement | null) => void;
    onMouseEnter: () => void;
    onClick: (event: MouseEvent<HTMLAnchorElement>) => void;
};

export function FallbackRowItem({
    row,
    id,
    isActive,
    isPending,
    isDisabled,
    itemRef,
    onMouseEnter,
    onClick,
}: Props) {
    return (
        <a
            id={id}
            role="option"
            aria-selected={isActive}
            aria-disabled={isDisabled || undefined}
            ref={itemRef}
            href={row.target.href}
            className={cx(style.item, { [style.itemActive]: isActive })}
            onMouseEnter={onMouseEnter}
            onClick={onClick}
        >
            <div className={style.thumbnail}>
                {row.kind === 'globe' ? <IconGlobe className={style.thumbnailIcon} /> : null}
                {row.kind === 'map' ? <IconMap className={style.thumbnailIcon} /> : null}
                {row.kind === 'top-destination' ? (
                    <Image
                        className={style.thumbnailImg}
                        src={row.destination.coverPicture.id}
                        alt=""
                        width={56}
                        height={56}
                        loader={imageLoaderForPicture(row.destination.coverPicture, {
                            aspectRatio: RATIO['1/1'],
                        })}
                    />
                ) : null}
            </div>
            <div className={style.content}>
                <Typography scale="primary-xs-bold" className={style.title}>
                    {row.target.label}
                </Typography>
            </div>
            {isPending ? (
                <span className={style.spinner} aria-hidden="true" data-testid="pending-spinner" />
            ) : (
                <IconChevronRight className={style.chevron} />
            )}
        </a>
    );
}
